
// import React, { useState, useEffect } from "react";
// import Grid from "@mui/material/Grid";
// import MDBox from "components/MDBox";
// import Card from "@mui/material/Card";
// import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
// import { styled } from "@mui/material/styles";
// import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
// import SnapshotCard from "./SnapshotCard";
// import BrandSnapshot from "./Type/BrandSnapshot";
// import MarketSnapshot from "./Type/MarketSnapshot";
// import ContentSnapshot from "./Type/ContentSnapshot";
// import CampaignSnapshot from "./Type/CampaignSnapshot";
// import { Typography } from "@mui/material";
// import MDTypography from "components/MDTypography";
// import BrandSnapshotImage from "../../../../assets/images/social-studio/brand-snapshot.png";
// import MarketSnapshotImage from "../../../../assets/images/social-studio/market-snapshot.png";
// import ContentSnapshotImage from "../../../../assets/images/social-studio/content-snapshot.png";
// import CampaignSnapshotImage from "../../../../assets/images/social-studio/campaign-snapshot.png";
// import ArrowBackIcon from "@mui/icons-material/ArrowBack";
// import IconButton from "@mui/material/IconButton";
// import SocialPopup from "./SocialPopup";
// import Grow from "@mui/material/Grow";
// import SnapshotStepper from "./Stepper/SnapshotStepper";

// // ─────────────────────────────────────────────────────────────
// // Tooltip setup
// // ─────────────────────────────────────────────────────────────
// const CustomTooltip = styled(({ className, ...props }) => (
//   <Tooltip {...props} classes={{ popper: className }} />
// ))({
//   [`& .${tooltipClasses.tooltip}`]: {
//     maxWidth: 400,
//     textAlign: "left",
//   },
// });

// const tooltipContent = (
//   <div style={{ maxWidth: "350px", textAlign: "left" }}>
//     <Typography variant="body2" gutterBottom>
//       <strong>How to Choose a Snapshot Type:</strong>
//     </Typography>
//     <Typography variant="caption" display="block" gutterBottom>
//       - Select the type of snapshot you want to create (e.g.,{" "}
//       <strong>Brand Snapshot</strong>, <strong>Campaign Snapshot</strong>).
//       <br />- Each type supports different workflows and analysis goals.
//     </Typography>
//     <Typography variant="body2" gutterBottom>
//       <strong>Quick Tips:</strong>
//     </Typography>
//     <Typography variant="caption" display="block">
//       - Choose a snapshot and preview it using the template.
//       <br />- Click on a card to begin building that type of snapshot.
//       <br />- You can go back and switch types at any time.
//     </Typography>
//   </div>
// );

// // ─────────────────────────────────────────────────────────────
// // Snapshot Types
// // ─────────────────────────────────────────────────────────────
// const snapshotTypes = [
//   {
//     title: "Brand Snapshot",
//     description:
//       "Compare your brand against competitors across key performance metrics. Ideal for pitch decks and monthly reviews.",
//     type: "brand",
//     image: BrandSnapshotImage,
//   },
//   {
//     title: "Market Snapshot",
//     description:
//       "Analyse how non-owned brands perform across your market. Great for prospect research and competitive landscape analysis.",
//     type: "market",
//     image: MarketSnapshotImage,
//   },
//   // {
//   //   title: "Content Snapshot",
//   //   description:
//   //     "Review your brand’s content strategy, sentiment, and engagement trends. Perfect for creative planning and optimization.",
//   //   type: "content",
//   //   image: ContentSnapshotImage,
//   // },
//   // {
//   //   title: "Campaign Snapshot",
//   //   description:
//   //     "Assess the performance of your campaign by engagement, and creative impact. Ideal for campaign wrap-ups and reporting.",
//   //   type: "campaign",
//   //   image: CampaignSnapshotImage,
//   // },
// ];

// const snapshotComponentMap = {
//   brand: BrandSnapshot,
//   market: MarketSnapshot,
//   content: ContentSnapshot,
//   campaign: CampaignSnapshot,
// };

// // ─────────────────────────────────────────────────────────────
// // Main Component
// // ─────────────────────────────────────────────────────────────
// function SocialSnapshot({ goBack, onComplete, editSnapshotData }) {
//   const [selectedSnapshotType, setSelectedSnapshotType] = useState(null);
//   const [confirmSelection, setConfirmSelection] = useState(false);
//   const [navHeight, setNavHeight] = useState(75);
//   const [isTransparent, setIsTransparent] = useState(true);

//   const steps = ["Select Snapshot Type", "Review & Generate Snapshot"];

//   // Track navbar height dynamically
//   useEffect(() => {
//     const navbarEl = document.querySelector("header.MuiAppBar-root");
//     if (navbarEl) setNavHeight(navbarEl.offsetHeight);

//     const resizeObserver = new ResizeObserver(() => {
//       if (navbarEl) setNavHeight(navbarEl.offsetHeight);
//     });

//     if (navbarEl) resizeObserver.observe(navbarEl);
//     return () => resizeObserver.disconnect();
//   }, []);

//   // Shadow toggle on scroll
//   useEffect(() => {
//     const handleScroll = () => setIsTransparent(window.scrollY === 0);
//     window.addEventListener("scroll", handleScroll);
//     handleScroll();
//     return () => window.removeEventListener("scroll", handleScroll);
//   }, []);

//   // Handle post-OAuth flow
//   useEffect(() => {
//     const intent = localStorage.getItem("postOAuthIntent");
//     const confirmed = localStorage.getItem("postOAuthConfirmed");

//     if (intent && snapshotComponentMap[intent]) {
//       setSelectedSnapshotType(intent);
//       if (confirmed === "true") setConfirmSelection(true);

//       localStorage.removeItem("postOAuthIntent");
//       localStorage.removeItem("postOAuthConfirmed");
//     }
//   }, []);

//   // ✅ If editing, auto-set snapshot type and confirm selection
//   useEffect(() => {
//     if (editSnapshotData && editSnapshotData.snapshotType) {
//       setSelectedSnapshotType(editSnapshotData.snapshotType.toLowerCase());
//       setConfirmSelection(true);
//     }
//   }, [editSnapshotData]);

//   const handleSnapshotConfirm = () => setConfirmSelection(true);

//   // ────────────────────────────────────────────────
//   // When a snapshot type is confirmed, render that type
//   // ────────────────────────────────────────────────
//   if (selectedSnapshotType && confirmSelection) {
//     const SnapshotComponent = snapshotComponentMap[selectedSnapshotType];
//     if (SnapshotComponent) {
//       return (
//         <SnapshotComponent
//           goBack={() => setConfirmSelection(false)}
//           onComplete={onComplete}
//           editSnapshotData={editSnapshotData || null} // ✅ Pass to sub-component
//         />
//       );
//     }
//   }

//   // ────────────────────────────────────────────────
//   // Default rendering — Step 1: Select Snapshot Type
//   // ────────────────────────────────────────────────
//   return (
//     <MDBox mt={-5}>
//       {/* 🧭 Stepper Bar (Sticky) */}
//       <MDBox
//         display="flex"
//         alignItems="center"
//         justifyContent="flex-start"
//         width="100%"
//         zIndex={1000}
//         bgcolor="white"
//         py={1}
//         px={1}
//         boxShadow={1}
//         sx={{
//           position: "sticky",
//           top: `${navHeight - 1}px`,
//           zIndex: 999,
//           backgroundColor: "#ffffff",
//           borderRadius: "8px",
//           gap: 2,
//           mb: 7,
//           boxShadow: isTransparent
//             ? "none"
//             : "0 4px 12px rgba(0, 0, 0, 0.2)",
//           transition:
//             "top 0.3s ease, background-color 0.3s ease, box-shadow 0.3s ease",
//         }}
//       >
//         <IconButton onClick={goBack} sx={{ color: "primary.main", ml: 1 }}>
//           <ArrowBackIcon />
//         </IconButton>

//         <MDBox flexGrow={1} pl={2}>
//           <SnapshotStepper steps={steps} activeStep={0} />
//         </MDBox>
//       </MDBox>

//       {/* 🟩 Snapshot Type Selection Section */}
//       <Card>
//         <MDBox>
//           <MDBox
//             mx={2}
//             mt={-3}
//             py={1}
//             px={2}
//             variant="gradient"
//             bgColor="info"
//             borderRadius="lg"
//             coloredShadow="info"
//             display="flex"
//             alignItems="center"
//           >
//             <MDTypography variant="h6" color="white">
//               Snapshot Type
//             </MDTypography>
//             <CustomTooltip title={tooltipContent} placement="bottom" arrow>
//               <IconButton sx={{ color: "white", p: 0, ml: 0.5 }}>
//                 <InfoOutlinedIcon fontSize="small" />
//               </IconButton>
//             </CustomTooltip>
//           </MDBox>

//           <MDBox
//             sx={{
//               maxWidth: "1440px",
//               mx: "auto",
//               mt: "20px",
//               mb: "25px",
//               px: "15px",
//             }}
//           >
//             <Grid container spacing={2} justifyContent="center">
//               {snapshotTypes.map((snapshot, index) => (
//                 <Grow
//                   in={true}
//                   timeout={index * 550}
//                   key={snapshot.type}
//                   style={{ transformOrigin: "0 0 0" }}
//                 >
//                   <Grid
//                     item
//                     xs={12}
//                     sm={6}
//                     md={6}
//                     lg={4}
//                     xl={3}
//                     sx={{ display: "flex", justifyContent: "center" }}
//                   >
//                     <SnapshotCard
//                       title={snapshot.title}
//                       description={snapshot.description}
//                       type={snapshot.type}
//                       image={snapshot.image}
//                       onClick={() =>
//                         setSelectedSnapshotType((prev) =>
//                           prev === snapshot.type ? null : snapshot.type
//                         )
//                       }
//                       isSelected={selectedSnapshotType === snapshot.type}
//                     />
//                   </Grid>
//                 </Grow>
//               ))}
//             </Grid>
//           </MDBox>
//         </MDBox>
//       </Card>

//       {/* 🧩 Bottom Popup (Continue) */}
//       <SocialPopup
//         selectedItems={selectedSnapshotType ? [selectedSnapshotType] : []}
//         actionLabel="Continue"
//         onContinue={handleSnapshotConfirm}
//         onBack={goBack}
//         onClearConfirm={null}
//         entityType="snapshot"
//       />
//     </MDBox>
//   );
// }

// export default SocialSnapshot;


// ########################################################


import React, { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import Card from "@mui/material/Card";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import SnapshotCard from "./SnapshotCard";
import BrandSnapshot from "./Type/BrandSnapshot";
import MarketSnapshot from "./Type/MarketSnapshot";
import ContentSnapshot from "./Type/ContentSnapshot";
import CampaignSnapshot from "./Type/CampaignSnapshot";
import { Typography } from "@mui/material";
import MDTypography from "components/MDTypography";
import BrandSnapshotImage from "../../../../assets/images/social-studio/brand-snapshot.png";
import MarketSnapshotImage from "../../../../assets/images/social-studio/market-snapshot.png";
import ContentSnapshotImage from "../../../../assets/images/social-studio/content-snapshot.png";
import CampaignSnapshotImage from "../../../../assets/images/social-studio/campaign-snapshot.png";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import IconButton from "@mui/material/IconButton";
import SocialPopup from "./SocialPopup";
import Grow from "@mui/material/Grow";
import SnapshotStepper from "./Stepper/SnapshotStepper";
import UpgradePopup from "layouts/components/Upgrade";
import SnapshotTypeGuidance from "layouts/guidance/components/SnapshotTypeGuidance";


// ─────────────────────────────────────────────────────────────
// Tooltip setup
// ─────────────────────────────────────────────────────────────
const CustomTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: 400,
    textAlign: "left",
  },
});

const tooltipContent = (
  <div style={{ maxWidth: "350px", textAlign: "left" }}>
    <Typography variant="body2" gutterBottom>
      <strong>How to Choose a Snapshot Type:</strong>
    </Typography>
    <Typography variant="caption" display="block" gutterBottom>
      - Select the type of snapshot you want to create (e.g.,{" "}
      <strong>Brand Snapshot</strong>, <strong>Campaign Snapshot</strong>).
      <br />- Each type supports different workflows and analysis goals.
    </Typography>
    <Typography variant="body2" gutterBottom>
      <strong>Quick Tips:</strong>
    </Typography>
    <Typography variant="caption" display="block">
      - Choose a snapshot and preview it using the template.
      <br />- Click on a card to begin building that type of snapshot.
      <br />- You can go back and switch types at any time.
    </Typography>
  </div>
);

// ─────────────────────────────────────────────────────────────
// Snapshot Types
// ─────────────────────────────────────────────────────────────
const snapshotTypes = [
  {
    title: "Brand Snapshot",
    description:
      "Compare your brand against competitors across key performance metrics. Ideal for pitch decks and monthly reviews.",
    type: "brand",
    image: BrandSnapshotImage,
  },
  {
    title: "Market Snapshot",
    description:
      "Analyse how non-owned brands perform across your market. Great for prospect research and competitive landscape analysis.",
    type: "market",
    image: MarketSnapshotImage,
  },
  // {
  //   title: "Content Snapshot",
  //   description:
  //     "Review your brand’s content strategy, sentiment, and engagement trends. Perfect for creative planning and optimization.",
  //   type: "content",
  //   image: ContentSnapshotImage,
  // },
  // {
  //   title: "Campaign Snapshot",
  //   description:
  //     "Assess the performance of your campaign by engagement, and creative impact. Ideal for campaign wrap-ups and reporting.",
  //   type: "campaign",
  //   image: CampaignSnapshotImage,
  // },
];

const snapshotComponentMap = {
  brand: BrandSnapshot,
  market: MarketSnapshot,
  content: ContentSnapshot,
  campaign: CampaignSnapshot,
};

// ─────────────────────────────────────────────────────────────
// Main Component
// ─────────────────────────────────────────────────────────────
function SocialSnapshot({ goBack, onComplete, editSnapshotData, entitlements, setGuidanceMessage, showGuidance = true, isLiveDemo = false }) { // [UPDATED]
  const [selectedSnapshotType, setSelectedSnapshotType] = useState(null);
  // ... (lines 409-633 omitted for brevity in call, but in file content)

  // Update line 634
  // <SnapshotTypeGuidance
  //   isHighlighted={isLiveDemo && showGuidance && snapshot.type === 'market' && !selectedSnapshotType} // [UPDATED]
  //   message="Click on Market Snapshot"
  // >

  // Update line 536 to pass showGuidance down
  //   showGuidance={showGuidance} // [NEW]
  //   isLiveDemo={isLiveDemo}

  // Update line 667
  //   demoHighlight={isLiveDemo && showGuidance && selectedSnapshotType === 'market'} // [UPDATED] Highlight Continue
  const [confirmSelection, setConfirmSelection] = useState(false);
  const [navHeight, setNavHeight] = useState(75);
  const [isTransparent, setIsTransparent] = useState(true);

  // [NEW] Usage & Feature Logic
  const [showUpgrade, setShowUpgrade] = useState(false);
  const [upgradeType, setUpgradeType] = useState("feature");
  const [usageRaw, setUsageRaw] = useState(null);

  // [NEW] Live Demo Logic
  // const isLiveDemo = sessionStorage.getItem('demo_role_cache') === "demo_viewer"; // [REMOVED] Used prop instead

  const steps = ["Select Snapshot Type", "Review & Generate Snapshot"];
  const FEATURE_KEY = "Snapshot";

  // Track navbar height dynamically
  useEffect(() => {
    const navbarEl = document.querySelector("header.MuiAppBar-root");
    if (navbarEl) setNavHeight(navbarEl.offsetHeight);

    const resizeObserver = new ResizeObserver(() => {
      if (navbarEl) setNavHeight(navbarEl.offsetHeight);
    });

    if (navbarEl) resizeObserver.observe(navbarEl);
    return () => resizeObserver.disconnect();
  }, []);

  // Shadow toggle on scroll
  useEffect(() => {
    const handleScroll = () => setIsTransparent(window.scrollY === 0);
    window.addEventListener("scroll", handleScroll);
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Handle post-OAuth flow
  useEffect(() => {
    const intent = localStorage.getItem("postOAuthIntent");
    const confirmed = localStorage.getItem("postOAuthConfirmed");

    if (intent && snapshotComponentMap[intent]) {
      setSelectedSnapshotType(intent);
      if (confirmed === "true") setConfirmSelection(true);

      localStorage.removeItem("postOAuthIntent");
      localStorage.removeItem("postOAuthConfirmed");
    }
  }, []);

  // ✅ If editing, auto-set snapshot type and confirm selection
  useEffect(() => {
    if (editSnapshotData && editSnapshotData.snapshotType) {
      setSelectedSnapshotType(editSnapshotData.snapshotType.toLowerCase());
      setConfirmSelection(true);
    }
  }, [editSnapshotData]);

  // [NEW] Fetch Usage Logic
  useEffect(() => {
    if (entitlements) {
      setUsageRaw({
        snapshotsUsed: entitlements.usage?.active_snapshots || 0,
        snapshotsLimit: entitlements.limits?.snapshots || 0,
        currentPlan: entitlements.plan || "Basic"
      });
    }
  }, [entitlements]);

  // const handleSnapshotConfirm = () => setConfirmSelection(true);
  const handleSnapshotConfirm = () => {
    // 🔒 1. CHECK ENTITLEMENT (Priority)
    // Check if feature list exists and if "Snapshot" is missing
    const isLocked = entitlements?.features && !entitlements.features.includes(FEATURE_KEY);

    if (isLocked) {
      setUpgradeType("feature");
      setShowUpgrade(true);
      return;
    }

    // 🔒 2. CHECK USAGE LIMIT
    if (usageRaw) {
      const { snapshotsUsed, snapshotsLimit } = usageRaw;
      // console.log("snapshotsUsed", snapshotsUsed);
      // console.log("snapshotsLimit", snapshotsLimit);
      if (Number(snapshotsUsed) >= Number(snapshotsLimit)) {
        setUpgradeType("usage");
        setShowUpgrade(true);
        return;
      }
    }

    setConfirmSelection(true);
  };

  // 🟢 NEW: Handle “View Template” Button Click
  const handleViewTemplate = () => {
    if (!selectedSnapshotType) return;

    let pdfPath = "";
    if (selectedSnapshotType === "brand") {
      pdfPath = "/templates/brand-snapshot-template.pdf";
    } else if (selectedSnapshotType === "market") {
      pdfPath = "/templates/market-snapshot-template.pdf";
    }

    if (pdfPath) {
      window.open(pdfPath, "_blank");
    } else {
      console.warn("No matching template found for selected snapshot type.");
    }
  };

  // ────────────────────────────────────────────────
  // When a snapshot type is confirmed, render that type
  // ────────────────────────────────────────────────
  if (selectedSnapshotType && confirmSelection) {
    const SnapshotComponent = snapshotComponentMap[selectedSnapshotType];
    if (SnapshotComponent) {
      return (
        <SnapshotComponent
          goBack={() => setConfirmSelection(false)}
          onComplete={onComplete}
          editSnapshotData={editSnapshotData || null}
          entitlements={entitlements}
          setGuidanceMessage={setGuidanceMessage}
          isLiveDemo={isLiveDemo}
          showGuidance={showGuidance} // [NEW]
        />
      );
    }
  }

  // ────────────────────────────────────────────────
  // Default rendering — Step 1: Select Snapshot Type
  // ────────────────────────────────────────────────
  return (
    <MDBox mt={-5}>
      {/* 🧭 Stepper Bar (Sticky) */}
      <MDBox
        display="flex"
        alignItems="center"
        justifyContent="flex-start"
        width="100%"
        zIndex={1000}
        bgcolor="white"
        py={1}
        px={1}
        boxShadow={1}
        sx={{
          position: "sticky",
          top: `${navHeight - 1}px`,
          zIndex: 999,
          backgroundColor: "#ffffff",
          borderRadius: "8px",
          gap: 2,
          mb: 4,
          boxShadow: isTransparent
            ? "none"
            : "0 4px 12px rgba(0, 0, 0, 0.2)",
          transition:
            "top 0.3s ease, background-color 0.3s ease, box-shadow 0.3s ease",
        }}
      >
        <IconButton onClick={goBack} sx={{ color: "primary.main", ml: 1 }}>
          <ArrowBackIcon />
        </IconButton>

        <MDBox flexGrow={1} pl={2}>
          <SnapshotStepper steps={steps} activeStep={0} />
        </MDBox>
      </MDBox>

      {/* 🟩 Snapshot Type Selection Section */}
      <Card>
        <MDBox>
          <MDBox
            mx={2}
            mt={-3}
            py={1}
            px={2}
            variant="gradient"
            bgColor="info"
            borderRadius="lg"
            coloredShadow="info"
            display="flex"
            alignItems="center"
          >
            <MDTypography variant="h6" color="white">
              Snapshot Type
            </MDTypography>
            <CustomTooltip title={tooltipContent} placement="bottom" arrow>
              <IconButton sx={{ color: "white", p: 0, ml: 0.5 }}>
                <InfoOutlinedIcon fontSize="small" />
              </IconButton>
            </CustomTooltip>
          </MDBox>

          <MDBox
            sx={{
              maxWidth: "1440px",
              mx: "auto",
              mt: "20px",
              mb: "25px",
              px: "15px",
            }}
          >
            <Grid container spacing={2} justifyContent="center">
              {snapshotTypes.map((snapshot, index) => (
                <Grow
                  in={true}
                  timeout={index * 550}
                  key={snapshot.type}
                  style={{ transformOrigin: "0 0 0" }}
                >
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={6}
                    lg={4}
                    xl={3}
                    sx={{ display: "flex", justifyContent: "center" }}
                  >
                    <SnapshotTypeGuidance
                      isHighlighted={isLiveDemo && showGuidance && snapshot.type === 'market' && !selectedSnapshotType}
                      message="Click on Market Snapshot"
                    >
                      <SnapshotCard
                        title={snapshot.title}
                        description={snapshot.description}
                        type={snapshot.type}
                        image={snapshot.image}
                        onClick={() =>
                          setSelectedSnapshotType((prev) =>
                            prev === snapshot.type ? null : snapshot.type
                          )
                        }
                        isSelected={selectedSnapshotType === snapshot.type}
                      />
                    </SnapshotTypeGuidance>
                  </Grid>
                </Grow>
              ))}
            </Grid>
          </MDBox>
        </MDBox>
      </Card>

      {/* 🧩 Bottom Popup (Continue + View Template) */}
      <SocialPopup
        selectedItems={selectedSnapshotType ? [selectedSnapshotType] : []}
        actionLabel="Continue"
        onContinue={handleSnapshotConfirm}
        onViewTemplate={handleViewTemplate}  // ✅ Added here
        onBack={goBack}
        onClearConfirm={null}
        entityType="snapshot"
        demoHighlight={isLiveDemo && showGuidance && selectedSnapshotType === 'market'} // [UPDATED] Highlight Continue
      />

      <UpgradePopup
        open={showUpgrade}
        onClose={() => setShowUpgrade(false)}
        type={upgradeType}
        featureName={FEATURE_KEY}
        planRequired={entitlements?.requiredPlans?.[FEATURE_KEY] || "Higher Plan"}
        currentPlan={usageRaw?.currentPlan}
        usageLimit={usageRaw?.snapshotsLimit}
        unit="snapshots"
      />
    </MDBox>
  );
}

export default SocialSnapshot;
